<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
      class="login-container"
    >
      <v-col 
        cols="12"
        align="center"
      >
        <p class="mb-5 fs-15">Un email à été envoyé à l'adresse {{ email }}. <br>Le lien vous permettra de réinitialiser votre mot de passe et celui-ci sera valable pendant 24h.</p>
        
        <v-btn
          color="primary"
          :to="{ name: 'Login' }"
        >
          Se connecter
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // LIBRARY
  import { validationMixin } from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { AUTH_RESET_PSWD } from '@/store/actions/auth'
  import { LOADING, LOADED } from '@/store/actions/general'

  export default {
    name: 'EmailSent',

    data: () => ({
      email: '',
    }),

    mounted() {
      EventBus.$emit(LOADED)
      this.email = this.$route.params.email
    }
  }
</script>

<style scoped>
  .red-text {
    color: red;
  }
  .fs-15 {
    font-size: 15px;
  }
</style>